import React from 'react'
import Header from './Header.js'
import Footer from './Footer.js'
import Sidebar from './Sidebar.js'
import TopHeader from './TopHeader.js'
import Hero from './Hero.js'
import BottomHeader from './BottomHeader.js'
import '../css/home.css'
import Category from './Category'
import ProductSlider from './ProductSlider'
import Products from './Products.js'
import BestSellers from './BestSellers'
import Library from './Library.js'
import Welcome from './Welcome.js'
import Watches from './Watches'
import Homeaccessory from './Homeaccessory.js'
import Story from './Story.js'
import About from './About.js'
import Follow from './Follow.js'

function Home() {
  const category2 = [{
    name: "Women's",
      src: '../shop-3.jpg',
      list: [{ name: 'New arrivals' }, { name: 'Discount sale collection' }, { name: 'More' }]
    }, {
      name: "Men's",
      src: '../shop-4.jpg',
      list: [{ name: 'New arrivals' }, { name: 'Discount sale collection' }, { name: 'More' }]
      
    }, {
      name: "Kid's",
      src: '../shop-5.jpg',
      list: [{ name: 'New arrivals' }, { name: 'Discount sale collection' }, { name: 'More' }]
  
    },
    ];
    const category1 = [{
      name: "Hand Held Radios",
      src: '../hand_held1.png',
      list: [{ name: 'Motorola Radios' }, { name: 'Hytera Radios' }, { name: 'ICOM Radios' }, { name: 'Baofeng Radios' }, { name: 'More' }]
    }, {
      name: "Base & VEH Stations and Repeaters",
      src: '../Repeater_Banner1.png',
      list: [{ name: 'Motorola Stations',link: '/products/motorola-radios' }, { name: 'Hytera Stations',link:'/products/hytera-stations' }, 
        { name: 'ICOM Stations' }, { name: 'Other' },]
      
    }
    ];
    const category3 = [{
      name: "Boxing & MMA Equipment",
      src: '../cat-1.jpg',
      list: [{ name: 'Computer & tablets' }, { name: 'Computer & photos' }, { name: 'Tv,audio & surveilance' }, { name: 'Cell phone & accessories' }, { name: 'More' }]
    }, {
      name: "Fitness,Running & Yoga Equipment",
      src: '../cat-2.jpg',
      list: [{ name: 'Vaccum & Floor Care ' }, { name: 'Washes & Dryers' }, { name: 'Refrigerators' }, { name: 'Dishwashes' }, { name: 'More' }]
      
    }
    ];
  
    const bestsellers1 = [
      {name: 'MOTOTRBO™ DP4801', src: '../dp4801.png'},
      {name: 'MOTOTRBO™ R7-D', src: '../R7-D.png'},
      {name: 'HYTERA PD78X Series', src: '../Hyterapd78X.png'},
      {name: 'HYTERA AP5X Series', src: '../Hyteraap58X.png'},
      {name: 'ICOM V8X Series', src: '../ICOMV8X.png'},
      {name: 'KENWOOD NX1200', src: '../kennx1200.png'},
    ];
    const bestsellers2 = [
      { name: 'MOTOTRBO™ DM4601E', src: '../MTDM4000.png' },
      { name: 'MOTOTRBO™ DM 14/1600', src: '../mtdm1600.png' },
      { name: 'HYTERA MD788G', src: '../md78xg.png' },
      { name: 'HYTERA MD628', src: '../md628xg.png' },
      { name: 'ICOM F5023', src: '../iCOMf5023x.png' },
      { name: 'KENWOOD TK7360', src: '../TK7360H.png' }
    ];
    const bestsellers3 = [
      { name: 'ZKTeco Walk Through Metal Detector', src: '../zktwgate.png' },
      { name: 'DAHUA Walk Through Metal Detector', src: '../dahua.png' },
      { name: 'ZKTeco Turnstile Entrance Gates', src: '../ts2000.png' },
      { name: 'ZKTeco QR/CNIC/Card Series Reader', src: '../qr500zk.png' },
      { name: 'Electro Magnetic Gates (EM)', src: '../EMg.png' },
      { name: 'E-Tag Vehicle System', src: '../boom.png' },
      // { name: 'HYTERA MD628', src: '../md628xg.png' },
      // { name: 'ICOM F5023', src: '../iCOMf5023x.png' },
      // { name: 'KENWOOD TK7360', src: '../TK7360H.png' }
    ];
  
  return (
    <>
    
     <Hero/>   
      <h3 className='heading-1'>VIEW ALL CATEGORIES</h3>
      <Category data={category1}  /> 
      {/* <Products />   */}
      {/* <About data={bestsellers1} /> */}
      {/* <div className='heading'>
        <h3>Best Hand Held Walkie Talkies</h3>
        <p>Check out our latest collections </p>
      </div>
      <div className='heading'>
        <h3>Best Base & Vehicle Stations</h3>
        <p>Check out our latest collections </p>
      </div> */}
      {/* <Category data={category2 } />
      <div className='heading'> 
         <h3>Clothing & Shoes</h3> 
         <p>Check out our latest collections </p> 
       </div> */}
       {/* <BestSellers data={bestsellers2} />

       <div className='heading'>
        <h3>WALK THROUGH AND ENTRANCE CONTROL GATES</h3>
        <p>Check out our latest collections </p>
      </div>
       <BestSellers data={bestsellers3} /> */}
       {/* <h3 className='heading-2'>VIEW STORE</h3> 
       <Category data={category3} /> 
      <div className='heading'>
        <h3>Premium Watches </h3>
        <p>Check out our latest collections </p>
      </div> */}
      {/* <div className='heading'>
        <h3>Other Accessories</h3>
        <p>Check out our latest collections </p>
      </div> */}
      {/* <Watches /> */}
      {/* <div className='heading'>
        <h3>Others accessories </h3>
        <p>Check out our latest collections </p>
      </div>
      <Homeaccessory /> */}
      {/* <h3 className='heading-2'>VIEW More</h3>
      <Story /> */}
      {/* <Follow /> */}
    </>
  )
}

export default Home